import { Navigate } from "react-router-dom";
import { isAutenticado } from "../services/authService";

export default function ProtectedRoute({ children }) {
  return isAutenticado() ? children : <Navigate to="/login" replace />;
}
